
import classNames from 'classnames';
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import { PreviewEventSignIn } from '../../connection/auth';
import { useTypedSelector } from '../../store/reducers/use-typed-selector';
import ModalComponent from '../general-ui/modal/modal';
import TextInput from '../general-ui/text-input/text';
import '../general-ui/modal/modal.scss';
import { FetchError } from 'connection/helpers';

type Props = {
	setIsModalPreview: Dispatch<SetStateAction<boolean | null | undefined>>
}

export default function PreviewPasscodeChecker(props: Props): JSX.Element {
	const {
		setIsModalPreview
	} = props;

	const eventBundle = useTypedSelector(event => event.LiveEventReducer.eventBundle);

	const [previewPasscode, setPreviewPasscode] = useState("");
	const [previewModalOpen, setPreviewModalOpen] = useState(true);
	const [errorPasscodePreview, setErrorPasscodePreview] = useState("");

	const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const val = e.target.value;
		setPreviewPasscode(val);
	};

	const submitPreviewPasscode = async () => {
		if (eventBundle?.uuid && previewPasscode) {
			try {
				const res = await PreviewEventSignIn(eventBundle?.uuid, previewPasscode);
				if (res.error)
					setErrorPasscodePreview(res.error);
				else {
					cancelModal();
					setIsModalPreview(false);
				}
			} catch (err) {
				if (err instanceof FetchError && err.error) {
					setErrorPasscodePreview(err.error);
				} else {
					setErrorPasscodePreview("There was a problem validating the passcode");
				}
			}

		}
	};

	const cancelModal = () => {
		setPreviewModalOpen(false);
	};

	return (
		<ModalComponent
			className='preview-passcode-checker'
			padTitle={false}
			cancellable={false}
			closeable={false}
			open={previewModalOpen}
			onRequestClose={cancelModal}
			title="View private link"
			isAdmin={false}
			footer={(
				<>
					<button
						className={classNames("lemonade", { "disabled": !previewPasscode })}
						onClick={submitPreviewPasscode}
						aria-disabled={!previewPasscode}
						tabIndex={previewPasscode ? undefined : -1}
					>
						Submit
					</button>
				</>
			)}
		>
			<div className={classNames("preview-password")}>
				<label>Passcode</label>
				<TextInput
					onChange={(e) => handleNameChange(e)}
					onFocus={() => setErrorPasscodePreview("")}
					placeholder="Passcode of your private link"
					value={previewPasscode}
				/>
				<p className="error-passcode-preview">{errorPasscodePreview}</p>
			</div>
		</ModalComponent>
	);
}
